
import Header from '@/components/header/Header.component.vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
export default {
    name: 'Home',
    components: {
        Header,
    },
    setup() {
        const { t } = useI18n();
        const title = t('components.sidebar.menu.home');
        const router = useRouter();
        const GoBack = () => router.back();
        return { title, GoBack };
    },
};
